import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import TileGrid from 'components/TileGrid';
import { getCookie } from 'helpers/Storage';
import { getCommonTealiumProps } from 'helpers/AccountHelper';
import {
  DEVICE_IOS,
  mobileDeviceType,
  LOCAL_CLIP_PAGE_COOKIE_NAME,
  COLLECTION_TYPE_LOCAL_CLIPS,
} from 'helpers/ContentHelper';
import { handleAnalytics, Events, getEndcardContentList } from '@foxcorp/delta-web-analytics';
import Style from './Endcard.module.scss';

class Endcard extends Component {
  componentDidMount() {
    const { endcardItems } = this.props;
    if (endcardItems) {
      const endCardContentList = getEndcardContentList({
        endcardItems,
        headerRecommended: window.Language?.videoPage_headerRecommended ?? '',
        headerUpNext: window.Language?.videoPage_headerUpNext ?? '',
      });
      let endcardContentLength = 0;
      if (endcardItems.length) {
        endcardContentLength = endcardItems.length > 1 ? 2 : endcardItems.length;
      }
      handleAnalytics({
        event: Events.EVENT_END_CARD_IMPRESSION,
        payload: {
          end_card_content_list: endCardContentList,
          end_card_content_length: endcardContentLength,
        },
        tealiumPayload: {
          end_card_content_list: endCardContentList,
          end_card_content_length: endcardContentLength,
          ...getCommonTealiumProps(),
        },
      });
      _.set(window, 'utag_data.collection_title', null);
    }
  }

  render() {
    const {
      continuousPlayback,
      endcardItems,
      mediaEndingSeconds,
      renderImage,
      videoProcessor,
      onClick,
      isFullscreen,
      isAuthenticated,
    } = this.props;

    if (!endcardItems) return null;

    let items = endcardItems;

    const {
      videoPage_headerRecommended: headerRecommended,
      videoPage_headerUpNext: headerUpNext,
    } = window.Language;

    if (items.length === 0) return null;

    items = items.slice(0, 2);

    // setup the up next counter
    if (items[0] && continuousPlayback) {
      items[0].counter = (
        <span className={Style.counter}>
          {headerUpNext}
          <span className={Style.seconds}>{mediaEndingSeconds}</span>
        </span>
      );
    }

    if (items[1]) {
      items[1].counter = <span className={Style.counter}>{headerRecommended}</span>;
    }
    const componentProps = {
      collectionType:
        getCookie({ name: LOCAL_CLIP_PAGE_COOKIE_NAME }) && COLLECTION_TYPE_LOCAL_CLIPS,
      items,
      gridType: 'grid-2-1',
      processor: videoProcessor,
      preventLazyLoad: true,
      tileType: 'tile-image-left',
      tileDetailToggle: false,
      tileTheme: Style,
      mediaEndingSeconds,
      renderImage,
      onTileClick: onClick,
      onTitleClick: onClick,
      isAuthenticated,
    };

    const className = [Style.playerEndcard];
    const containerClasses = [Style.endCardContainer];
    const isIosDevice = mobileDeviceType() === DEVICE_IOS;

    if (items.length === 1) className.push(Style.single);
    if (isFullscreen) {
      className.push(Style.fullscreen);
      containerClasses.push(Style.containerFull);
    }

    if (isFullscreen && isIosDevice) className.push(Style.hideEndCard);

    return (
      <div className={classNames(containerClasses)}>
        <div className={classNames(className)}>
          <TileGrid {...componentProps} />
        </div>
      </div>
    );
  }
}
Endcard.defaultProps = {
  continuousPlayback: null,
  endcardItems: null,
  isAuthenticated: null,
  isFullscreen: null,
  mediaEndingSeconds: null,
  renderImage: PropTypes.func,
  onClick: () => {},
  videoProcessor: () => {},
};
Endcard.propTypes = {
  continuousPlayback: PropTypes.bool,
  endcardItems: PropTypes.arrayOf(PropTypes.shape({})),
  isAuthenticated: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  mediaEndingSeconds: PropTypes.number,
  renderImage: PropTypes.func,
  onClick: PropTypes.func,
  videoProcessor: PropTypes.func,
};

export default Endcard;
